import html2pdf from "html2pdf.js/dist/html2pdf.bundle.min.js";

/**
 * Export a DOM node as a PDF using html2pdf.js.
 * Options:
 * - filename: string
 */
export async function exportGaitReportPdf(element, options = {}) {
  if (!element) return;
  const { filename = "gait-report.pdf" } = options;

  const opt = {
    // Slightly wider side margins so scaled content (graphs + axis labels)
    // does not clip at the PDF edge after html2pdf fits the block to the page.
    margin: [10, 12, 10, 12],
    filename,
    image: { type: "jpeg", quality: 0.95 },
    html2canvas: {
      // Balance sharpness vs. layout: 2 can exaggerate sub-pixel overflow in PDF.
      scale: 1.75,
      useCORS: true,
      scrollX: 0,
      scrollY: 0,
    },
    // Generate a US Letter portrait document to match clinic printing.
    jsPDF: {
      unit: "pt",
      format: "letter",
      orientation: "portrait",
    },
    // Hint to html2pdf.js that graph cards and other report sections
    // should not be split across pages. The CSS rules on the relevant
    // classes work together with these options.
    pagebreak: {
      mode: ["css", "legacy"],
      avoid: [".gait-report__graph-card", ".gait-report__section"],
    },
  };

  // html2pdf returns a promise when using the fluent API
  await html2pdf().set(opt).from(element).save();
}

